function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
import { getDebugLevel } from "./utils/debug";
import { version } from "./config";
var debugLevel = getDebugLevel();
var debugging = !!debugLevel;
var start = Date.now();
var getDelta = function() {
    var delta = Date.now() - start;
    if (delta >= 36e5) {
        return "" + (delta / 36e5).toFixed(2) + "h";
    }
    if (delta >= 6e4) {
        return "" + (delta / 6e4).toFixed(2) + "m";
    }
    return "" + (delta / 1e3).toFixed(2) + "s";
};
export var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger() {}
    var _proto = Logger.prototype;
    _proto.log = function log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (debugging) {
            var _console;
            (_console = console).log.apply(_console, [
                this.prefix
            ].concat(_to_consumable_array(args)));
        }
    };
    _proto.LOG = function LOG() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _console;
        (_console = console).log.apply(_console, [
            this.prefix
        ].concat(_to_consumable_array(args)));
    };
    _proto.warn = function warn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (debugging) {
            var _console;
            (_console = console).warn.apply(_console, [
                this.prefix
            ].concat(_to_consumable_array(args)));
            if (debugLevel === "warn") {
                throw _construct(Error, _to_consumable_array(args));
            }
        }
    };
    _proto.WARN = function WARN() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _console;
        (_console = console).warn.apply(_console, [
            this.prefix
        ].concat(_to_consumable_array(args)));
    };
    _proto.error = function error() {
        for(var _len = arguments.length, err = new Array(_len), _key = 0; _key < _len; _key++){
            err[_key] = arguments[_key];
        }
        if (debugging) {
            var _console;
            (_console = console).error.apply(_console, [
                this.prefix
            ].concat(_to_consumable_array(err)));
            if (debugLevel === "warn" || debugLevel === "error") {
                throw _construct(Error, _to_consumable_array(err));
            }
        }
    };
    _proto.ERROR = function ERROR() {
        for(var _len = arguments.length, err = new Array(_len), _key = 0; _key < _len; _key++){
            err[_key] = arguments[_key];
        }
        var _console;
        (_console = console).error.apply(_console, [
            this.prefix
        ].concat(_to_consumable_array(err)));
    };
    _create_class(Logger, [
        {
            key: "prefix",
            get: // eslint-disable-next-line class-methods-use-this
            function get() {
                return "Lapel(v" + version + ") " + getDelta();
            }
        }
    ]);
    return Logger;
}();
export default new Logger();

//# sourceMappingURL=logger.js.map